import { gql } from '@apollo/client';
import { queryAllResidentData } from 'services/query/residents';

export const CREATE_RESIDENT = gql`
  mutation createResident($data: ResidentInput!) {
    createResident(data: $data) {
      id
    }
  }
`;

export const UPDATE_RESIDENT = gql`
  mutation updateResident($data: UpdateResidentInput!) {
    updateResident(data: $data) {
      ${queryAllResidentData}
      bed {
        id
        label
      }
    }
  }
`;

export const DELETE_RESIDENT = gql`
  mutation deleteResident($id: String!) {
    deleteResident(id: $id)
  }
`;

export const TOGGLE_RESIDENT_ACTIVE_STATE = gql`
  mutation toggleResidentActiveState($id: String!, $isActive: Boolean!) {
    toggleResidentActiveState(residentId: $id, isActive: $isActive)
  }
`;

export const RESTORE_RESIDENT = gql`
  mutation restoreResident($id: ID!) {
    restoreResident(id: $id) {
      id
    }
  }
`;
